import { render, staticRenderFns } from "./EditableLabel.vue?vue&type=template&id=71193f78"
import script from "./EditableLabel.vue?vue&type=script&lang=js"
export * from "./EditableLabel.vue?vue&type=script&lang=js"
import style0 from "./EditableLabel.vue?vue&type=style&index=0&id=71193f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports